/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Tab from "vux/src/components/tab/tab.vue";
import TabItem from "vux/src/components/tab/tab-item.vue";
import Popup from "vux/src/components/popup/index.vue";
import PopupHeader from "vux/src/components/popup-header/index.vue";
import TransferDom from "vux/src/directives/transfer-dom/index.js";
import { getAreaList as _getAreaList, getAreaInfo } from '@/api';
export default {
  name: 'TAddressOnline',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    address: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    level: {
      type: Number,
      default: 4,
      validator: function validator(n) {
        return [1, 2, 3, 4].includes(n);
      }
    }
  },
  directives: {
    TransferDom: TransferDom
  },
  components: {
    Tab: Tab,
    TabItem: TabItem,
    Popup: Popup,
    PopupHeader: PopupHeader
  },
  computed: {
    active: function active() {
      return this.selectedValue.length ? this.selectedValue.length - 1 : 0;
    },
    realList: function realList() {
      var _this = this;

      return [{
        data: this.areaJson
      }, {
        data: this.cityData
      }, {
        data: this.districtData
      }, {
        data: this.streetData
      }].filter(function (_, i) {
        return i < _this.level;
      });
    },
    adsLevel: function adsLevel() {
      var _this2 = this;

      return ['选择省份', '选择城市', '选择区域', '选择街道'].filter(function (_, i) {
        return i < _this2.level;
      });
    },
    currValue: {
      get: function get() {
        var _this3 = this;

        if (this.address.length) {
          this.$nextTick(function () {
            _this3.setPositon();
          });
        }

        return this.value;
      },
      set: function set(v) {
        this.$emit('input', v);
      }
    }
  },
  watch: {
    selectedValue: {
      handler: function handler() {
        var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        if (array[0]) {
          this.getAreaList(array[0].id, 'cityData');
        } else {
          this.cityData = [];
        }

        if (array[1]) {
          this.getAreaList(array[1].id, 'districtData');
        } else {
          this.districtData = [];
        }

        if (array[2]) {
          this.getAreaList(array[2].id, 'streetData');
        } else {
          this.streetData = [];
        }
      },
      deep: true
    },
    address: function address(v) {
      if (v.length) {
        this.getAddressName();
      }
    }
  },
  data: function data() {
    return {
      selectedValue: [],
      areaJson: [],
      cityData: [],
      districtData: [],
      streetData: []
    };
  },
  created: function created() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this4.getAreaList(1, 'areaJson');

            case 2:
              if (!_this4.address.length) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return _this4.getAddressName();

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getAddressName: function getAddressName() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var ids, _yield$getAreaInfo, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ids = _this5.address.filter(Boolean).join(',');
                _context2.next = 3;
                return getAreaInfo({
                  ids: ids
                });

              case 3:
                _yield$getAreaInfo = _context2.sent;
                data = _yield$getAreaInfo.data;
                _this5.selectedValue = data.list;
                console.log(1, _this5.selectedValue);

                _this5.$emit('show-name', _this5.selectedValue.map(function (v) {
                  return v.name;
                }));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getAreaList: function getAreaList(id, list) {
      var _this6 = this;

      return _getAreaList({
        pid: id
      }).then(function (_ref) {
        var success = _ref.success,
            data = _ref.data;

        if (data.msg === "success") {
          _this6[list] = data.list;
        } else {
          _this6[list] = [];
        }
      });
    },
    rigthClick: function rigthClick() {
      this.currValue = false;
      console.log(2, this.selectedValue);
      this.$emit('on-change', this.selectedValue.map(function (v) {
        return v.id;
      }), this.selectedValue.map(function (v) {
        return v.name;
      }));
    },
    setPositon: function setPositon() {
      var _this7 = this;

      this.selectedValue.forEach(function (v, i) {
        if (v && v.id && _this7.realList[i]) {
          var index = _this7.realList[i].data.findIndex(function (value) {
            return value.id === v.id;
          });

          _this7.$refs['area-list'][i].scroll(0, 32 * index);
        }
      });
    },
    click: function click(area) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this.selectedValue.length - 1 > type) {
        this.selectedValue.splice(type, this.selectedValue.length - type, area);
      } else {
        this.$set(this.selectedValue, type, area);
      }
    },
    saveData: function saveData() {
      console.log(4, this.selectedValue);
      this.$emit('on-change', this.selectedValue.map(function (v) {
        return v.id;
      }));
    }
  }
};